// eslint-disable-next-line no-restricted-imports
import { ExecutionPlaceFragment } from 'api/generated/graphql';
import { ExecutionPlaceEntity } from 'api/types/entity/executionPlaceEntity';

export const parseExecutionPlaceEntity = (
  data: ExecutionPlaceFragment
): ExecutionPlaceEntity => ({
  id: data.id,
  name: data.name,
});
